
import { useQuery } from '@tanstack/react-query';
import { useProperties } from './useProperties';
import { useMemo } from 'react';
import { titleToSlug } from '@/utils/stringUtils';

export const usePropertyBySlug = (titleSlug: string) => {
  const { data: properties = [], isLoading: propertiesLoading, error: propertiesError } = useProperties();

  // Create a memoized lookup map for better performance
  const propertyLookup = useMemo(() => {
    if (!properties.length) return new Map();
    
    const lookup = new Map();
    properties.forEach(property => {
      const slug = titleToSlug(property.title);
      lookup.set(slug, property);
    });
    return lookup;
  }, [properties]);

  return useQuery({
    queryKey: ['property-by-slug', titleSlug],
    queryFn: () => {
      const property = propertyLookup.get(titleSlug);
      
      if (!property) {
        return null;
      }

      return property;
    },
    enabled: !!titleSlug && properties.length > 0,
    staleTime: 10 * 60 * 1000, // 10 minutes - increased from 5
    gcTime: 20 * 60 * 1000, // 20 minutes cache
  });
};
